import {lazy} from 'react';

export {default as FallbackSidebar} from './FallbackSidebar';
export {getSidebarWidth} from './getSidebarWidth';
export {default as MarkedLocation} from './MarkedLocation';

export const LayersSidebar = lazy(
    () => import(/* webpackChunkName: "LayersSidebar" */ './LayersSidebar')
);
export const AreaDetailsSidebar = lazy(
    () => import(/* webpackChunkName: "AreaDetailsSidebar" */ './AreaDetailsSidebar')
);
export const EditAreaSidebar = lazy(
    () => import(/* webpackChunkName: "EditAreaSidebar" */ './EditAreaSidebar')
);
export const EditLayersSidebar = lazy(
    () => import(/* webpackChunkName: "EditLayersSidebar" */ './EditLayersSidebar')
);
export const LayerDetailsSidebar = lazy(
    () => import(/* webpackChunkName: "LayerDetailsSidebar" */ './LayerDetailsSidebar')
);
export const OverlaysSidebar = lazy(
    () => import(/* webpackChunkName: "OverlaysSidebar" */ './OverlaysSidebar')
);
export const PreferencesSidebar = lazy(
    () => import(/* webpackChunkName: "PreferencesSidebar" */ './PreferencesSidebar')
);
export const PrintSidebar = lazy(
    () => import(/* webpackChunkName: "PrintSidebar" */ './PrintSidebar')
);
export const SavedItemsSidebar = lazy(
    () => import(/* webpackChunkName: "SavedItemsSidebar" */ './SavedItemsSidebar')
);
export const CustomSourceSidebar = lazy(
    () => import(/* webpackChunkName: "CustomSourceSidebar" */ './CustomSourceSidebar')
);
export const LandSidebar = lazy(
    () => import(/* webpackChunkName: "LandSidebar" */ './selections/map/LandSidebar')
);
export const TrailAndPoiSidebar = lazy(
    () => import(/* webpackChunkName: "TrailAndPoiSidebar" */ './selections/map/TrailAndPoiSidebar')
);
export const KnownRouteSidebar = lazy(
    () => import(/* webpackChunkName: "KnownRouteSidebar" */ './selections/map/KnownRouteSidebar')
);
export const KnownRoutesSidebar = lazy(
    () => import(/* webpackChunkName: "KnownRoutesSidebar" */ './selections/map/KnownRoutesSidebar')
);
export const WaypointDetailsSidebar = lazy(
    () => import(/* webpackChunkName: "WaypointDetailsSidebar" */ './WaypointDetailsSidebar')
);
export const InteractionSpecSidebar = lazy(
    () =>
        import(
            /* webpackChunkName: "InteractionSpecSidebar" */ './selections/map/InteractionSpecSidebar'
        )
);
export const EditWaypointSidebar = lazy(
    () => import(/* webpackChunkName: "EditWaypointSidebar" */ './EditWaypointSidebar')
);
export const TrackDetailsSidebar = lazy(
    () => import(/* webpackChunkName: "TrackDetailsSidebar" */ './TrackDetailsSidebar')
);
export const EditTrackSidebar = lazy(
    () => import(/* webpackChunkName: "EditTrackSidebar" */ './EditTrackSidebar')
);
export const EditFolderSidebar = lazy(
    () => import(/* webpackChunkName: "EditFolderSidebar" */ './EditFolderSidebar')
);
export const ClickDisambiguationSidebar = lazy(
    () =>
        import(/* webpackChunkName: "ClickDisambiguationSidebar" */ './ClickDisambiguationSidebar')
);
export const WeatherDetailsSidebar = lazy(
    () => import(/* webpackChunkName: "WeatherDetailsSidebar" */ './Weather/WeatherDetailsSidebar')
);
export const FolderDetailsSidebar = lazy(
    () => import(/* webpackChunkName: "FolderDetailsSidebar" */ './FolderDetailsSidebar')
);
export const ShareFolderSidebar = lazy(
    () => import(/* webpackChunkName: "ShareFolderSidebar" */ './ShareFolderSidebar')
);
